<div class="trace-accordion_wrapper" [class.trace-accordion-initial-closed]="initialClosed()">
  <p-accordion [styleClass]="'trace-accordion text-gray-500'">
    <p-accordion-panel value="0">
      <p-accordion-header>Debug Info</p-accordion-header>
      <p-accordion-content>
          @if (conversationId) {
            <div class="trace trace_id">
              <div class="font-semibold text-sm text-gray-700 mb-1">Conversation ID</div>
              <span class="font-mono break-all text-gray-700 text-xs">
              {{ conversationId }}
            </span>
              <button
                pButton
                type="button"
                icon="pi pi-copy"
                class="p-button-sm p-button-text py-0 h-6"
                pTooltip="Copy Conversation ID"
                tooltipPosition="top"
                (click)="copyToClipboard(conversationId)"
              ></button>
            </div>
          }
          @if (messageId) {
            <div class="trace trace_id">
              <div class="font-semibold text-sm text-gray-700 mb-1">Message ID</div>
              <span class="font-mono break-all text-gray-700 text-xs">
              {{ messageId }}
            </span>
              <button
                pButton
                type="button"
                icon="pi pi-copy"
                class="p-button-sm p-button-text py-0 h-6"
                pTooltip="Copy Message ID"
                tooltipPosition="top"
                (click)="copyToClipboard(messageId)"
              ></button>
            </div>
          }
        @let traceId = message.metadata?.['trace_id'];
        @if (traceId) {
          <div class="trace trace_id">
            <div class="font-semibold text-sm text-gray-700 mb-1">Trace ID</div>
            <span class="font-mono break-all text-gray-700 text-xs">
              {{ traceId }}
            </span>
            <button
              pButton
              type="button"
              icon="pi pi-copy"
              class="p-button-sm p-button-text py-0 h-6"
              pTooltip="Copy Trace ID"
              tooltipPosition="top"
              (click)="copyToClipboard(traceId)"
            ></button>
          </div>
        }

        @for (trace of message.traces; track trace.index; let i = $index) {
          <div class="trace markdown-body" [ngClass]="{ 'with-border': i > 0 }">
            @if (trace.reasoning) {
              <div class="font-semibold text-sm text-gray-700 mb-1">Reasoning</div>
              <markdown [data]="trace.reasoning"></markdown>
            }

            @if (trace.rationale) {
              <div class="font-semibold text-sm text-gray-700 mt-3 mb-1">Rationale</div>
              <markdown [data]="trace.rationale"></markdown>
            }

            @if (trace.toolUsage) {
              <div class="font-semibold text-sm text-gray-700 mt-3 mb-1">Tool Usage</div>
              <markdown [data]="'```json\n' + (trace.toolUsage | json) + '\n```'"></markdown>
            }
          </div>
        }
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
